// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-0e712614],\nth[data-v-0e712614] {\n  vertical-align: middle;\n}\na.element__span[data-v-0e712614],[data-v-0e712614] .element__span a {\n  color: #5664d2 !important;\n}\na.element__span[data-v-0e712614]:hover,[data-v-0e712614] .element__span a:hover {\n  color: rgb(51.5186915888, 67.546728972, 193.4813084112) !important;\n}", ""]);
// Exports
module.exports = exports;
